/** Whole-module policy when a module has no list entries (biography, video, …). */
export const MODULE_ENTRY_WHOLE_MODULE_KEY = '__module__';
